
























































































import CustomFieldChip from "@/components/report/CustomFieldChip.vue";
import CustomFieldDetailIcon from "@/components/report/CustomFieldDetailIcon.vue";
import CustomFieldForm from "@/components/report/CustomFieldForm.vue";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { CustomField } from "@/models/custom-field.entity";
import {
  MrfiktivCustomFieldViewModelGen,
  MrfiktivCustomFieldListElementViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { CustomFieldCreateDtoHelper } from "@/store/modules/custom-field.store";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { RefsCustomFieldModule } from "@/store/modules/refs.store";
import { debounce } from "debounce";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import draggable from "vuedraggable";

@Component({
  components: {
    CustomFieldChip,
    CustomFieldDetailIcon,
    CustomFieldForm,
    draggable
  }
})
export default class SelectCustomFields extends mixins(PermissionMixin) {
  readonly CustomField = CustomField;

  loadingLocal = false;
  search = "";
  menuWidth = 400;
  isCreateDialogActive = false;
  isCreateValid = false;
  createCustomFieldDto = new CustomFieldCreateDtoHelper();

  dragged = {
    from: -1,
    to: -1,
    newIndex: -1
  };

  @Prop({ default: () => [] })
  value!: MrfiktivCustomFieldListElementViewModelGen[];

  @Prop({ default: false })
  disabled!: boolean;

  @Prop({ default: false })
  readonly!: boolean;

  @Prop({ default: false })
  loading!: boolean;

  @Prop({ default: true })
  showManageButton!: boolean;

  @Prop({ default: true })
  showCreateDialog!: boolean;

  @Prop({ default: () => "views.CustomFieldList.selectCustomField" })
  label!: string;

  // Extract custom fields for the autocomplete (store works with ICustomField)
  get selectedCustomFields(): MrfiktivCustomFieldViewModelGen[] {
    return this.value.map(item => item.customField);
  }

  set selectedCustomFields(newCustomFields: MrfiktivCustomFieldViewModelGen[]) {
    // Map back to CustomFieldListElement format, preserving configurations
    const newList: MrfiktivCustomFieldListElementViewModelGen[] = newCustomFields.map(cf => {
      // Find existing configuration or create default
      const existingItem = this.value.find(item => item.customField.id === cf.id);

      if (existingItem) {
        // Preserve existing configuration
        return {
          customField: cf,
          configuration: existingItem.configuration
        };
      } else {
        // Create new item with default configuration
        return {
          customField: cf,
          configuration: { isRequired: false }
        };
      }
    });

    this.$emit("input", newList);
    this.$emit("change", newList);
  }

  get isLoading(): boolean {
    return this.loading || this.loadingLocal;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get partnerId() {
    return this.partner.id;
  }

  // Make sure that selected items are in list of items (they should not be filtered out - otherwise the list of selected items would be misleading)
  get items() {
    const filteredItems = RefsCustomFieldModule.filteredAndSorted || [];
    const selectedItems = this.selectedCustomFields || [];

    const filteredItemIds = new Set(filteredItems.map(item => item.id));
    const missingSelectedItems = selectedItems.filter(cf => !filteredItemIds.has(cf.id));

    return [...filteredItems, ...missingSelectedItems];
  }

  move(value: any) {
    this.dragged = {
      from: parseInt(value.from.id),
      to: parseInt(value.to.id),
      newIndex: value.draggedContext.futureIndex
    };
  }

  handleCustomFieldOrderChange(value: any) {
    const selected = this.selectedCustomFields;
    if (value.removed) {
      // insert
      selected.splice(this.dragged.to + this.dragged.newIndex, 0, selected[this.dragged.from]);
      // delete
      if (this.dragged.from <= this.dragged.to)
        // LTR
        selected.splice(this.dragged.from, 1);
      // RTL
      else selected.splice(this.dragged.from + 1, 1);
    }
    this.selectedCustomFields = selected;
  }

  @Watch("search")
  async onSearchChange(search: string) {
    if (search && !this.itemsExist(search)) {
      this.debounceQuerySelections(search);
    }
  }

  private itemsExist(customFieldName: string) {
    return this.items && this.items.some(i => i.name === customFieldName);
  }

  debounceQuerySelections = debounce(this.querySelections, 500);

  async querySelections(search: string) {
    this.loadingLocal = true;

    try {
      if (UserModule.abilities.can(ActionEnum.READ, BackendResourceEnum.CUSTOM_FIELD, this.partnerId)) {
        RefsCustomFieldModule.setFilters([]);
        RefsCustomFieldModule.setSearch(search);
        await RefsCustomFieldModule.fetchFirstPage({ partnerId: this.partnerId });
      }
    } catch (error) {
      handleError(error);
    } finally {
      this.loadingLocal = false;
    }
  }

  mounted() {
    RefsCustomFieldModule.setFilters([]);
    this.querySelections("");

    this.$nextTick(() => {
      const container = this.$refs.container as HTMLElement;
      if (container) {
        this.menuWidth = container.offsetWidth;
      }
    });
  }

  beforeDestroy() {
    RefsCustomFieldModule.setFilters([]);
    RefsCustomFieldModule.setSearch("");
  }
}
